<template>
  <div class="authentication-wrapper authentication-basic container-p-y">
    <div class="authentication-inner">
      <div class="card">
        <div class="card-body">
          <!-- Logo -->
          <div class="app-brand justify-content-center">
            <a href="/" class="app-brand-link gap-2">
              <span class="app-brand-logo demo">
                  <img src="https://edctpalumninetwork.org/assets/img/branding/logo.svg" alt="EDCTP Logo">
              </span>
            </a>
          </div>

          <div style="text-align: center; margin-bottom: 2rem;">
            <h4 class="mb-2">Welcome to EDCTP Alumni network!</h4>
            <p class="mb-4">This area of the platform is restricted to EDCTP Fellows and Regional Networks of Excellence.</p>
          </div>
          <!-- Error Message Display -->
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>

          <form @submit.prevent="handleLogin">
            <div class="mb-3">
              <label for="username" class="form-label">Email</label>
              <input
                type="email"
                class="form-control"
                id="username"
                v-model="form.username"
                :class="{ 'is-invalid': errors.username }"
                placeholder="Enter your email"
                autofocus
                required
              />
              <div class="invalid-feedback" v-if="errors.username">
                {{ errors.username }}
              </div>
            </div>

            <div class="mb-3 form-password-toggle">
              <div class="input-group input-group-merge">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  class="form-control"
                  v-model="form.password"
                  :class="{ 'is-invalid': errors.password }"
                  placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                  required
                />
                <span class="input-group-text cursor-pointer" @click="showPassword = !showPassword">
                  <i class="bi" :class="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </span>
                <div class="invalid-feedback" v-if="errors.password">
                  {{ errors.password }}
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="remember-me" v-model="form.remember_me" />
                <label class="form-check-label" for="remember-me">Remember Me</label>
              </div>
              <div class="d-flex justify-content-between">
                <label class="form-label" for="password"> </label>
                <router-link to="/forgot-password">
                  <small>Forgot Password?</small>
                </router-link>
              </div>
            </div>


            <div class="mb-3">
              <button class="btn btn-primary d-grid w-100" type="submit" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                {{ loading ? 'Signing in...' : 'Sign in' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',

  data() {
    return {
      form: {
        username: '', // Changed from 'email' to 'username' to match API
        password: '',
        remember_me: false // Changed from 'remember' to 'remember_me' to match API
      },
      showPassword: false,
      errors: {},
      errorMessage: ''
    }
  },

  computed: {
    ...mapGetters('auth', ['loading', 'error']),

    appName() {
      return process.env.VUE_APP_NAME || 'EDCTP Admin'
    }
  },

  methods: {
    ...mapActions('auth', ['login']),

    async handleLogin() {
      this.errors = {}
      this.errorMessage = ''

      try {
        const result = await this.login(this.form)

        if (result.success) {
          // Login successful - redirect handled by AuthenticationService
          console.log('Login successful')
        } else {
          // Show error message
          this.errorMessage = result.message || 'Login failed'
        }
      } catch (error) {
        console.error('Login error:', error)

        // Handle different types of errors
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors
        } else if (error.response?.data?.message) {
          this.errorMessage = error.response.data.message
        } else if (error.message) {
          this.errorMessage = error.message
        } else {
          this.errorMessage = 'Login failed. Please try again.'
        }
      }
    }
  },

  watch: {
    // Clear error message when user starts typing
    'form.username'() {
      this.errorMessage = ''
      this.errors = {}
    },
    'form.password'() {
      this.errorMessage = ''
      this.errors = {}
    }
  }
}
</script>

<style scoped>
.authentication-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  width: 100%;
  background-image: url('/public/19.jpg');
  background-size: cover;
  background-repeat: no-repeat
}

.authentication-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 55, 61, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.card {
  box-shadow: 0 0.25rem 1rem rgba(161, 172, 184, 0.45);
  border: 0;
  max-width: 400px;
  margin: 0 auto;
}

.app-brand {
  margin-bottom: 1.5rem;
}

.app-brand-text {
  color: #009CAD;
  font-size: 1.5rem;
}

.cursor-pointer {
  cursor: pointer;
}

.form-password-toggle .input-group-text:hover {
  background-color: #f8f9fa;
}

.alert {
  border-radius: 0.375rem;
  font-size: 0.875rem;
}

.alert-danger {
  background-color: #ffe6e6;
  border-color: #ffcccc;
  color: #d63031;
}

.is-invalid {
  border-color: #ff3e1d;
}

.is-invalid:focus {
  border-color: #ff3e1d;
  box-shadow: 0 0 0 0.2rem rgba(255, 62, 29, 0.25);
}

.invalid-feedback {
  color: #ff3e1d;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
</style>
